import React, { useRef, useEffect, useState } from "react";
import { Grid } from "@react-three/drei";
import { useThree, useFrame } from "@react-three/fiber";

const gridConfig = {
  name: "grid",
  rotation: [1.5, 0, 0],
  position: [0, 0, -10],
  gridSize: [10, 10],
  infiniteGrid: true,
  cellColor: "#858585",
  cellSize: 1,
  cellThickness: 0.9,
  sectionSize: 10,
  sectionThickness: 1.35,
  sectionColor: "#829595",
  fadeDistance: 10000,
  fadeStrength: 0,
};

function GridView({ grid }) {
  const gridRef = useRef(null);
  const { camera } = useThree();
  const [frameCount, setFrameCount] = useState(0);

  useFrame(() => {
    setFrameCount(prev => {
      const newCount = prev + 1;
      if (newCount % 20 === 0) {
        gridResizing(grid, gridRef.current, camera);
      }
      return newCount;
    });
  });

  return <Grid ref={gridRef} {...gridConfig} />;
}

function gridResizing(grid, gridRef, camera) {
  if (!grid || !gridRef) return;
  if (camera.zoom > 100) {
    gridRef.material.cellSize = 0.1;
    gridRef.material.sectionSize = 1;
  } else if (camera.zoom > 6 && camera.zoom <= 100) {
    gridRef.material.cellSize = 1;
    gridRef.material.sectionSize = 10;
  } else if (camera.zoom <= 6) {
    gridRef.material.cellSize = 10;
    gridRef.material.sectionSize = 10;
  }
}

export default GridView;
